import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import StepTitle from '../../../common/StepTitle';
import WizardNavigator from '../../../common/WizardNavigator';
import PricingTermCard from './PricingTermCard';
import { css } from 'react-emotion';
import Button from '../../../common/Button';
import isEqual from 'lodash/isEqual';

const singleCard = css`
  margin: 0 auto;
  max-width: 600px;
`;

class SetupPricingTermStep extends PureComponent {
  static defaultProps = {};

  state = {
    termInfo: {},
    termHasValidationError: null,
    termTypeSelected: false
  };

  componentDidUpdate(prevProps, prevState) {
    const { termInfo } = this.state;
    if (!isEqual(prevState.termInfo, termInfo)) {
      const { onChange } = this.props;
      onChange({ productPricingTerm: termInfo });
    }
  }

  onPrev = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.previous);
  };

  onNext = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.next);
  };

  checkTypeSelected = termTypeSelected => {
    this.setState({ termTypeSelected });
  };

  validateForm = termHasValidationError => {
    this.setState({ termHasValidationError });
  };

  createTerm = termInfo => {
    this.setState({ termInfo });
  };

  render() {
    const {
      t,
      flow: { productPricingTerm, selectedSkus }
    } = this.props;
    const { termHasValidationError, termTypeSelected } = this.state;

    const invalidConditionReason = termTypeSelected
      ? t('createContract:messages.missingFieldsMessage')
      : t('createContract:pricingContract.mustSelectAPriceModel');

    return (
      <div>
        <StepTitle
          icon="product-pricing-terms-l"
          title={t('createContract:pricingContract.header')}
          description={t('createContract:pricingContract.description')}
        />

        <PricingTermCard
          className={singleCard}
          productPricingTerm={productPricingTerm}
          flow={this.props.flow}
          onCreateTerm={this.createTerm}
          skus={selectedSkus}
          validateForm={this.validateForm}
          checkTypeSelected={this.checkTypeSelected}
        />

        <WizardNavigator
          onPrev={this.onPrev}
          onNext={this.onNext}
          customNext={
            <Button
              className="btn btn-primary"
              disabled={termHasValidationError}
              disabledTooltipContents={invalidConditionReason}
              onClick={this.onNext}>
              Next
            </Button>
          }
        />
      </div>
    );
  }
}

export default withWizard(withTranslation()(SetupPricingTermStep));
